import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Filter from '../Filters/Filter';
import useFetch from '../../../useFetch';
import Paginate from '../../../Paginate';
import DeletePopup from '../DeletePopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Dropdown, Form, FormCheck, Image, Table } from 'react-bootstrap';
import ActionPopup from '../ActionPopup';

const Index = () => {
    document.title = "Customer IRP List | Smart Trucking Services";
    
    let navigate = useNavigate();
    
    const [searchParams, setSearchParams] = useSearchParams();

    var url = new URL(process.env.REACT_APP_BASE_API_URL+'/irp-expiry-report');
    for (const [key, value] of searchParams.entries())
    {
        url.searchParams.set(key, value);
    }

    const [sort, setSort] = useState({column: 'legal', type: 'asc'})
    const [apiUrl, setApiUrl] = useState(url);

    const filters = {
        action: apiUrl,
        method: 'GET',
        fields: [
            {
                label: 'IRP Expiry Start',
                type: 'input',
                subType: 'date',
                name: 'start',
            },
            {
                label: 'IRP Expiry End',
                type: 'input',
                subType: 'date',
                name: 'end',
            },
            // {
            //     label: 'Search Options',
            //     type: 'select',
            //     name: 'condition',
            //     values: [
            //         { text: 'All', value: '' },
            //         { text: 'New', value: 'new' },
            //         { text: 'Used', value: 'used' },
            //     ]
            // },
        ],
    };

    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    const { response, isLoading, error: fetchError } = useFetch(apiUrl, sort);

    useEffect(() => {
        setItems(response?.customers?.data ?? []);
        setMeta(response?.customers?.meta ?? []);
    }, [response])

    useEffect(() => {
        for (const [key, value] of searchParams.entries())
        {
            url.searchParams.set(key, value);
        }
        setApiUrl(url);
    }, [searchParams])

    const handleSort = (column) => {
        setSort(sort => {
            var type = 'asc'
            if (sort?.column == column)
            {
                type = sort?.type == 'asc' ? 'desc' : 'asc'
            }

            return {column: column, type: type}
        })

        setCurrentPage(0);
        var url = new URL(apiUrl);
        url.searchParams.delete('page');
        setApiUrl(url);
    }

    return (
        <div className="container-fluid">
            <Filter setApiUrl={setApiUrl} setCurrentPage={setCurrentPage} filters={filters} />
            
            <Card className="shadow mb-4">
                <Card.Header className="d-flex align-items-center justify-content-between">
                    <h5 className="h5 mb-0 text-gray1-800 font-weight-bold text-primary mr-3">Customer IRP List</h5>
                    <Button as={Link} target="_blank" to={'print?p=1&'+searchParams.toString()+'&sort='+sort?.column+'&sort_type='+sort?.type} variant="primary" className="btn-sm mr-2">Print</Button>
                </Card.Header>
                <Card.Body>
                    { fetchError && <div className="alert-msg-danger"><h3 className="mb-0"><strong>{ fetchError }</strong></h3></div> }

                    { isLoading && <h5 className="text-center">Loading Data</h5> }
                    
                    { !fetchError && !isLoading ? (
                        items?.length == 0 ? <h5 className="text-center text-danger">No data found</h5> : (
                            <>
                                <Table responsive bordered hover striped>
                                    <thead>
                                        <tr>
                                            <th className="text-center">#</th>
                                            <th onClick={() => handleSort('legal')} className={`${sort?.column == 'legal' ? 'sort-'+sort?.type : ''}`}>Legal Name</th>
                                            <th onClick={() => handleSort('fleet1')} className={`${sort?.column == 'fleet1' ? 'sort-'+sort?.type : ''}`}>Fleet 1</th>
                                            <th onClick={() => handleSort('expiry1')} className={`${sort?.column == 'expiry1' ? 'sort-'+sort?.type : ''}`}>Expiry Date</th>
                                            <th onClick={() => handleSort('fleet2')} className={`${sort?.column == 'fleet2' ? 'sort-'+sort?.type : ''}`}>Fleet 2</th>
                                            <th onClick={() => handleSort('expiry2')} className={`${sort?.column == 'expiry2' ? 'sort-'+sort?.type : ''}`}>Expiry Date</th>
                                            <th onClick={() => handleSort('fleet3')} className={`${sort?.column == 'fleet3' ? 'sort-'+sort?.type : ''}`}>Fleet 3</th>
                                            <th onClick={() => handleSort('expiry3')} className={`${sort?.column == 'expiry3' ? 'sort-'+sort?.type : ''}`}>Expiry Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { items?.map((item, index) => (
                                            <tr key={ item.id }>
                                                <td className="bg-dark text-white align-middle text-center">{ (currentPage*75) + index + 1 }</td>
                                                <td><Link to={`/customer-list/edit/${item.id}`}>{ item.legal_name }</Link></td>
                                                <td>{ item.irp_acc_1 }</td>
                                                <td>{ item.expire_date_1 }</td>
                                                <td>{ item.irp_acc_2 }</td>
                                                <td>{ item.expire_date_2 }</td>
                                                <td>{ item.irp_acc_3 }</td>
                                                <td>{ item.expire_date_3 }</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Paginate
                                    url={apiUrl}
                                    setUrl={setApiUrl}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    pageCount={meta?.last_page}
                                />

                                <i className="d-block text-center">{meta?.total ? `(${meta?.total} records found)` : null}</i>
                            </>
                        )
                    ) : null}
                </Card.Body>
            </Card>
        </div>
    );
}
 
export default Index;